// SettingsPanel.jsx - Settings panel component
import React from 'react';
import './SettingsPanel.css';

function SettingsPanel({ onClose }) {
  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-panel" onClick={(e) => e.stopPropagation()}>
        <div className="settings-header">
          <h2>Settings</h2>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="settings-content">
          <div className="settings-section">
            <h3>API Configuration</h3>
            <div className="setting-item">
              <label>Together AI API Key</label>
              <input 
                type="password" 
                placeholder="Configured in aiService.js"
                disabled
              />
              <small>Edit in: src/services/aiService.js</small>
            </div>
            <div className="setting-item">
              <label>Alpha Vantage API Key</label>
              <input 
                type="password" 
                placeholder="Configured in alphaVantageService.js"
                disabled
              />
              <small>Edit in: src/services/alphaVantageService.js</small>
            </div>
            <div className="setting-item">
              <label>Brave Search API Key</label>
              <input 
                type="password" 
                placeholder="Configured in braveSearchService.js"
                disabled
              />
              <small>Edit in: src/services/braveSearchService.js</small>
            </div>
          </div>

          <div className="settings-section">
            <h3>Features</h3>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Automatic Price Lookup
              </label>
              <small>AI automatically fetches crypto/stock prices when detected</small>
            </div>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Automatic Web Search
              </label>
              <small>AI automatically searches the web when needed</small>
            </div>
            <div className="setting-item">
              <label>
                <input type="checkbox" defaultChecked disabled />
                Code Syntax Highlighting
              </label>
              <small>Automatically highlights code blocks in responses</small>
            </div>
          </div>

          <div className="settings-section">
            <h3>About</h3>
            <div className="about-info">
              <p><strong>Baba AI</strong></p>
              <p>Version: 1.0.0</p>
              <p>AI Model: Meta-Llama-3.1-405B-Instruct-Turbo</p>
              <p>Provider: Together AI</p>
            </div>
          </div>

          <div className="settings-section">
            <h3>Data Management</h3>
            <div className="setting-item">
              <button 
                className="danger-btn"
                onClick={() => {
                  if (window.confirm('Delete all chats? This cannot be undone.')) {
                    localStorage.removeItem('baba-ai-chats');
                    window.location.reload();
                  }
                }}
              >
                Clear All Chats
              </button>
              <small>This will permanently delete all your chat history</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPanel;
